import React, {Component} from 'react';
import renderRoutes from 'react-router-config/es/renderRoutes';
import connect from 'react-redux/es/connect/connect';
import {createLocation} from 'history';

import OfferLoading from '../Components/OfferLoading/OfferLoading.jsx';
import OfferLayout from '../Components/OfferLayout/OfferLayout.jsx';

import api from '../../../../api.js';
import {generate} from '../../../routes.js';
import {loadUniverseById} from '../../../components/UniverseLoader/actions.js';
import {redirectToNotFound} from '../../Errors/actions.js';
import {withRouter, matchPath} from "react-router-dom";

class OfferDetailsContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      offer: null,
      loading: false,
      loaded: false
    }
  }

  componentDidMount = async () => {
    if (this.props.match.params.offer && this.state.offer === null && !this.state.loaded) {
      await this.loadOffer(true);
    }
  }

  componentDidUpdate(prevProps, prevState, prevContext) {
    if (null === this.state.offer && this.state.loaded) {
      this.props.redirectToNotFound();
      return
    }
    if (null !== this.state.offer && this.props.currentUniverseId !== this.state.offer.universe) {
      const match = matchPath(this.props.location.pathname, {
        path: '/annonces/:offer([A-z0-9-]+)/edit',
        exact: true,
      })

      if(null === match) {
        this.props.loadUniverseById(this.state.offer.universe);
      }
    }
  }

  loadOffer = async (doLoading) => {
    try {
      if (doLoading) {
        this.setState({loading: true});
      }

      const offer = parseInt(this.props.match.params.offer, 10) ?
        (await api.offers.getOne({offer: this.props.match.params.offer})).data :
        (await api.offers.getOneBySlug({slug: this.props.match.params.offer})).data;

      this.setState({
        offer: this.props.liftOffer(offer),
      });
    } catch (e) {
      console.warn(e);
    } finally {
      this.setState({loading: false, loaded: true});
    }
  };

  goToEdit = (offer) => {
    this.props.history.push(createLocation(
      generate({
        name: 'offers.details.edit',
        parameters: {
          offer: offer.slug
        },
      })
    ))
  };

  goToOffer = (offer) => {
    this.props.history.push(createLocation(
      generate({
        name: 'offers.details.show',
        parameters: {
          offer: offer.slug
        }
      })
    ));
  };

  onRefresh = async () => {
    await this.loadOffer(false);
  };

  render() {
    if (!this.state.loading && this.state.loaded && null !== this.state.offer) {
      return renderRoutes(this.props.route.routes, {
        currentUser: this.props.currentUser,
        flattenOffer: this.props.flattenOffer,
        freelance: this.props.freelance,
        goToEdit: this.goToEdit,
        goToOffer: this.goToOffer,
        liftOffer: this.props.liftOffer,
        offer: this.state.offer,
        refresh: this.onRefresh,
        withLayout: true,
      });
    }

    return (
      <OfferLayout>
        <OfferLoading/>
      </OfferLayout>
    );
  }
}

export default connect(
  (state) => ({
    userNotFound: state.errors.userNotFound,
    currentUniverseId: state.universe?.currentUniverse?.id ?? null
  }),
  (dispatch) => ({
    loadUniverseById: (universeId) => dispatch(loadUniverseById(universeId)),
    redirectToNotFound: () => dispatch(redirectToNotFound())
  })
)(withRouter(OfferDetailsContainer));